import { Injectable } from '@angular/core';
import { AdminService } from '@admin/services/admin.service';

@Injectable({
  providedIn: 'root',
})
export class UserTypesResolver {
  constructor(private admin: AdminService) {}

  public resolve() {
    return this.admin.getUserTypes();
  }
}
